import {
  CALCULATE_TAX_START,
  CALCULATE_TAX_SUCCESS,
  CALCULATE_TAX_FAIL,
  CREATE_BILLING_START,
  CREATE_BILLING_SUCCESS,
  CREATE_BILLING_FAIL,
  GET_STRIPE_KEY_START,
  GET_STRIPE_KEY_SUCCESS,
  GET_STRIPE_KEY_FAIL,
  GET_UPGRADE_PLANS_START,
  GET_UPGRADE_PLANS_SUCCESS,
  GET_UPGRADE_PLANS_FAIL,
  SET_UPGRADE_COMPLETE,
} from 'actions/upgradePlans';

export const defaultState = {
  error: false,
  loading: true,
  data: {},
  orderDetails: {},
  stripePublishableKey: '',
  taxInfo: '',
  upgradeComplete: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case CALCULATE_TAX_START:
      return {
        ...state,
        taxInfo: 'PURCHASE_DETAILS_TAX_CALCULATING',
      };
    case GET_STRIPE_KEY_START:
    case GET_UPGRADE_PLANS_START:
      return {
        ...state,
        loading: true,
        taxInfo: '',
      };
    case CALCULATE_TAX_SUCCESS:
      return {
        ...state,
        error: false,
        taxInfo: action.payload.totalTax,
      };
    case GET_STRIPE_KEY_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        stripePublishableKey: action.payload.stripePublishableKey,
      };
    case GET_UPGRADE_PLANS_SUCCESS: {
      const data = Object.values(action.payload).reduce(
        (accumulator, plan) =>
          Object.assign(accumulator, { [plan.planId]: plan }),
        {},
      );
      return {
        ...state,
        error: false,
        loading: false,
        data,
      };
    }
    case CREATE_BILLING_SUCCESS:
      return {
        ...state,
        orderDetails: action.payload,
      };
    case CALCULATE_TAX_FAIL:
      return {
        ...state,
        taxInfo: '',
      };
    case GET_STRIPE_KEY_FAIL:
      return {
        ...state,
        error: true,
        loading: false,
        stripePublishableKey: '',
      };
    case GET_UPGRADE_PLANS_FAIL:
      return {
        ...state,
        error: true,
        loading: false,
        data: {},
      };
    case CREATE_BILLING_FAIL:
      return {
        ...state,
        orderDetails: {},
      };
    case SET_UPGRADE_COMPLETE:
      return {
        ...state,
        upgradeComplete: {
          ...state.upgradeComplete,
          [action.payload]: true,
        },
      };
    case CREATE_BILLING_START:
    default:
      return state;
  }
};
